import { useMemo } from 'react';

import { useSearchParams } from 'react-router-dom';

import dayjs from 'dayjs';

export const useReportSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getString = (key) => searchParams.get(key) ?? '';

  const getFirstDayOfCurrentMonth = () => {
    return dayjs().startOf('month').format('YYYY-MM-DD');
  };

  const searchData = useMemo(
    () => ({
      period: getString('period') || null,
      startDate: getString('startDate') || getFirstDayOfCurrentMonth(),
      endDate: getString('endDate'),
      creatorId: getString('creatorId'),
      department: getString('department'),
      leadSourceId: getString('leadSourceId'),
      offerId: getString('offerId'),
      statusId: getString('statusId'),
      tab: getString('tab') || 'Conversion Overview',
    }),
    [searchParams]
  );

  const setReportSearchData = (updated) => {
    const nextParams = new URLSearchParams();
    const fullSearchData = { ...searchData, ...updated };

    if (!(Object.keys(updated).length === 1 && 'page' in updated)) {
      fullSearchData.page = 1;
    }

    const appendKey = (key, value) => {
      if (Array.isArray(value)) {
        value.forEach((v) => nextParams.append(key, v));
      } else if (value !== null && value !== undefined && value !== '') {
        if (value && typeof value === 'object' && value.format) {
          nextParams.set(key, value.format('YYYY-MM-DD'));
        } else {
          nextParams.set(key, value);
        }
      }
    };

    Object.entries(fullSearchData).forEach(([key, value]) => {
      appendKey(key, value);
    });

    setSearchParams(nextParams, { replace: true });
  };

  const resetSearchData = () => {
    const defaultParams = {
      period: 'daily',
      startDate: '',
      endDate: '',
      creatorId: '',
      department: '',
      leadSourceId: '',
      tab: 'Overview',
      page: 1,
      limit: 10,
      sortOrder: 'desc',
    };

    const nextParams = new URLSearchParams();

    const appendKey = (key, value) => {
      if (Array.isArray(value)) {
        value.forEach((v) => nextParams.append(key, v));
      } else if (value !== null && value !== undefined && value !== '') {
        nextParams.set(key, value);
      }
    };

    Object.entries(defaultParams).forEach(([key, value]) => {
      appendKey(key, value);
    });

    setSearchParams(nextParams, { replace: true });
  };

  return {
    searchData,
    setReportSearchData,
    resetSearchData,
  };
};
